"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = exports.StyledLoader = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const React = __importStar(require("react"));
const loading_spinner_svg_1 = __importDefault(require("./loading-spinner.svg"));
exports.StyledLoader = styled_1.default.div `
	display: block;
	background: url(${loading_spinner_svg_1.default});
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center center;
	font: 0/0 a;
	height: 100%;
`;
const Loader = (props) => {
    const loading = ('loading' in props) ? props.loading : true;
    return (!loading ? null : React.createElement(exports.StyledLoader, null));
};
exports.Loader = Loader;
//# sourceMappingURL=Loader.js.map